import _extends from "@swc/helpers/src/_extends.mjs";
import React, { lazy, Suspense, useRef, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { BiData } from '@wix/da-bi/pkg/events';
import { URLS } from '@wix/da-url';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import ChatIcon from '@wix/da-ds/pkg/Icons/24x24/Chat';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import IconButtonWithNotification from '@wix/da-ds/pkg/Buttons/IconButtonWithNotification';
import ErrorBoundary from '../../../ErrorBoundary';
import { useVerification } from '../../../VerificationPopup/withVerification';
import throttle from 'lodash/throttle';
const DesktopChatPanelDropdown = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "chat" */ '../../../Chat/ChatPanel/DesktopChatPanelDropdown')));
import retry from '../../../utils/webpack/chunkRetry';
import s from './ChatButtonAndDropdown.scss';
export const ChatButtonAndDropdown = ({ chatCount , className , iconClassName , numberClassName , disableDropdown , disableFloatingChat , isOpen =false , onOpen , onClose  })=>{
    const { t  } = useTranslation();
    const isMounted = useIsMounted();
    const { isVerificationNeeded , pushVerificationPopup  } = useVerification();
    const rootRef = useRef(null);
    const enterTimerRef = useRef();
    const throttledMouseLeave = useMemo(()=>throttle(()=>{
            clearTimeout(enterTimerRef.current);
            onClose && onClose();
        }, 300), [
        onClose
    ]);
    const onMouseEnter = ()=>{
        enterTimerRef.current = setTimeout(()=>{
            onOpen && onOpen();
        }, 100);
    };
    const onClosed = useCallback(()=>{
        throttledMouseLeave();
    }, [
        throttledMouseLeave
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onClosed,
        ref: rootRef
    }, !isVerificationNeeded && /*#__PURE__*/ React.createElement(TextButton, {
        className: s['a11y-toggle'],
        size: "medium",
        variant: "main",
        "aria-haspopup": true,
        "aria-expanded": isOpen,
        "aria-controls": "site-header-chat",
        onClick: isOpen ? onClose : onOpen
    }, t('siteHeader.chat.open')), /*#__PURE__*/ React.createElement(IconButtonWithNotification, _extends({
        icon: ChatIcon,
        size: "medium",
        notificationColor: "red",
        iconButtonClassName: iconClassName,
        numberClassName: numberClassName,
        count: chatCount,
        biData: BiData({
            evid: 700,
            link_name: 'chat',
            indicator: chatCount
        })
    }, isVerificationNeeded ? {
        onClick: ()=>pushVerificationPopup('chat'),
        'aria-label': t('siteHeader.a11y.openAccountVerificationDialog')
    } : {
        href: URLS.CHAT_HOME,
        'aria-label': t('chat.panel.a11y.chatButtonLink')
    })), /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "ChatButtonAndDropdown"
    }, isMounted && isOpen && !disableDropdown && /*#__PURE__*/ React.createElement(Suspense, {
        fallback: null
    }, /*#__PURE__*/ React.createElement(DesktopChatPanelDropdown, {
        id: "site-header-chat",
        className: classnames(s['dropdown'], isOpen && s['open'], s['a11y-dropdown']),
        disableFloatingChat: disableFloatingChat,
        onClose: onClosed
    }))));
};
ChatButtonAndDropdown.displayName = 'ChatButtonAndDropdown';
export default ChatButtonAndDropdown;
